import { useEffect, useState } from 'react';

import { ReferenceLine, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import { servGetGraficoDetalhamentoMetrica, servGetGraficoDetalhamentoEstabelecimento } from '../../../servicos/graficos_indicador';
import { servGetMetricaByEstabelecimento } from '../../../servicos/metrica_estabelecimento';
import { servGetmetricas } from '../../../servicos/metrica';
import { extraiNumeroMeta, formataOperadoresRelacionaisMetrica } from '../../../util/utilitarios';

function LineChartDetalhamentoIndicadorOuEstabelecimento({ dataInicio, dataFim, estabelecimento }) {

    console.log('### Iniciando LineChartDetalhamentoIndicadorOuEstabelecimento ###');

    const [dadosIndicadores, setDadosIndicadores] = useState(null)
    const [metricas, setMetricas] = useState(null)

    useEffect(() => {

        if (!estabelecimento) {
            // Se não passar o estabelecimento
            // Então exibe o detalhamento por metrica
            getAllMetricas()
            getGraficoDetalhamentoMetrica()
        } else {
            getMetricaByEstabelecimento();
            getGraficoDetalhamentoEstabelecimento();
        }

    }, [estabelecimento, dataInicio, dataFim]);

    const getGraficoDetalhamentoMetrica = async () => {
        try {
            const calculoIndicadoresPorMetricaDaApi = await servGetGraficoDetalhamentoMetrica(dataInicio, dataFim)
            setDadosIndicadores(calculoIndicadoresPorMetricaDaApi.data);
        } catch (erro) {
            console.error(erro);
        }
    }

    const getAllMetricas = async () => {
        try {
            const metricasDaApi = await servGetmetricas(true)
            setMetricas(metricasDaApi);
        } catch (erro) {
            console.error(erro);
        }
    }

    // Funcoes filtrando por estabelecimento

    const getMetricaByEstabelecimento = async () => {
        try {
            const metricasDaApi = await servGetMetricaByEstabelecimento(estabelecimento.id)
            setMetricas(metricasDaApi.data)
        } catch (erro) {
            console.error(erro);
        }
    }

    const getGraficoDetalhamentoEstabelecimento = async () => {
        try {
            const indicadorMetricaPorPeriodoFiltroEstabelecimentDaApi = await servGetGraficoDetalhamentoEstabelecimento(estabelecimento.id, dataInicio, dataFim)
            setDadosIndicadores(indicadorMetricaPorPeriodoFiltroEstabelecimentDaApi.data)
        } catch (erro) {
            console.error(erro);
        }
    }

    function filtraMetricaId(array, metricaId) {
        const filteredData = array.filter(item => item.metricaId === metricaId);
        return filteredData
    }

    const CustomTooltip = ({ payload, label, active, meta }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ background: "#fff", border: "1px solid #ccc", padding: 8 }}>
                    <p>{`Mês: ${label}`}</p>
                    <p>{`Resultado: ${payload[0].value}`}</p>
                    <p>{`Meta: ${meta}`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className='p-3'>
            <div className='text-center mt-3'>
                {estabelecimento && <p>Unidade Selecionada: <strong>{estabelecimento.nome}</strong></p>}
            </div>
            <div className='d-flex flex-column flex-md-row row justify-content-center'>
                {dadosIndicadores ? metricas && (
                    metricas.map((metrica) => {
                        const filteredData = filtraMetricaId(dadosIndicadores, metrica.id)
                        const metricaNumerico = extraiNumeroMeta(metrica.meta)
                        return (
                            <div key={metrica.id} className='col-12 col-sm-4 div-com-borda' style={{ 'height': '40em' }}>
                                <div className='d-flex justify-content-center align-items-center text-center' style={{ 'height': '15%' }}>
                                    <p className='m-0'>{metrica.codigo} - {metrica.descricao}</p>
                                </div>
                                <ResponsiveContainer width='100%' height='75%'>
                                    <LineChart data={filteredData} >

                                        <CartesianGrid strokeDasharray="4 4" />
                                        <XAxis dataKey="mesReferencia" />
                                        <YAxis domain={['dataMin - 5', 'dataMax + 20']} allowDecimals={false} />

                                        <Tooltip content={<CustomTooltip meta={formataOperadoresRelacionaisMetrica(metrica.meta)} />} />

                                        <ReferenceLine
                                            y={metricaNumerico}
                                            stroke="#dc3545"
                                            ifOverflow="extendDomain"
                                            strokeDasharray="4 4"
                                        />

                                        <Line type="monotone"
                                            dot={false}
                                            dataKey="resultado"
                                            stroke="#0088FE"
                                            label={{ fontSize: 14 }}
                                        />

                                    </LineChart>
                                </ResponsiveContainer>
                                <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                                    <p className='m-0' style={{ 'fontSize': '0.8em' }}>Fonte: {metrica.fonte}</p>
                                </div>
                            </div>
                        )
                    })
                ) :
                    (<p>Carregando...</p>)
                }
            </div>
        </div>
    )
}

export default LineChartDetalhamentoIndicadorOuEstabelecimento

